import { call, Effect, ForkEffect, put, takeEvery } from 'redux-saga/effects';
import { authActions } from './slice';
import { errorMessages } from '../../containers/common/utils/constants';
import axiosInstance from '../../containers/common/utils/axios-service';
import { AxiosResponse } from 'axios';
import { signIn, signOut } from '../../containers/common/utils/auth-service';
import { errorToast } from '../../containers/common/utils/alert';

const getSignInUrlAsync: () => Promise<AxiosResponse> =
  async (): Promise<AxiosResponse> => {
    return await signIn();
  };

const getSignOutUrlAsync: () => Promise<AxiosResponse> =
  async (): Promise<AxiosResponse> => {
    return await axiosInstance.post('signOut');
  };

export function* watchGetSignInUrlAsync(): Generator<Effect, void> {
  try {
    const res = (yield call(getSignInUrlAsync)) as AxiosResponse;

    if (res?.data) {
      yield put(authActions.getSignInUrlSuccess(res?.data));
    } else {
      errorToast(errorMessages.ErrorMessageInSignIn);
      yield put(
        authActions.getSignInUrlFail(
          errorMessages.ErrorMessageInvalidDataFormat
        )
      );
    }
  } catch (error) {
    errorToast(errorMessages.ErrorMessageInSignIn);
    yield put(authActions.getSignInUrlFail(errorMessages.ErrorMessageInSignIn));
  }
}

export function* watchGetSignOutUrlAsync(): Generator<Effect, void> {
  try {
    const res = (yield call(getSignOutUrlAsync)) as AxiosResponse;
    if (res?.data) {
      signOut(res?.data);
      yield put(authActions.getSignOutUrlSuccess(res.data));
    } else {
      errorToast(errorMessages.ErrorMessageInSignOut);
      yield put(
        authActions.getSignOutUrlFail(
          errorMessages.ErrorMessageInvalidDataFormat
        )
      );
    }
  } catch (error) {
    errorToast(errorMessages.ErrorMessageInSignOut);
    yield put(
      authActions.getSignOutUrlFail(errorMessages.ErrorMessageInSignOut)
    );
  }
}

export function* watchAuthSagas(): Generator<ForkEffect, void> {
  yield takeEvery(authActions.getSignInUrl, watchGetSignInUrlAsync);
  yield takeEvery(authActions.getSignOutUrl, watchGetSignOutUrlAsync);
}

const authSagas = watchAuthSagas;

export default authSagas;
